/* ============================================================
   Passi nei Sassi — product page behaviours
   1) Interactive itinerary (data from the section blocks, via JSON)
   2) Booking widget DEMO (placeholder — to be replaced by a Shopify app)
   (Header / drawer / sticky CTA / reveal live in pns-chrome.js.)
   ============================================================ */
(function () {
  'use strict';

  /* ───────── interactive itinerary ───────── */
  (function () {
    var root = document.getElementById('iti');
    if (!root) return;

    var STOPS = [];
    var dataEl = document.querySelector('[data-iti-stops]');
    if (dataEl) { try { STOPS = JSON.parse(dataEl.textContent) || []; } catch (e) { STOPS = []; } }
    if (!STOPS.length) return;

    var ICONS = {
      clock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>',
      pin:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>',
      cam:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="12" cy="13" r="4"/><path d="M9 3v3M15 3v3"/></svg>',
      tix:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 12V8H6a2 2 0 0 1-2-2c0-1.1.9-2 2-2h12v4"/><path d="M4 6v12c0 1.1.9 2 2 2h14v-4"/><path d="M18 12a2 2 0 0 0 0 4h4v-4Z"/></svg>'
    };

    var card = document.getElementById('itiCard');
    var fb = card ? card.querySelector('.iti-card-fb') : null;
    var body = document.getElementById('itiBody');
    var counter = document.getElementById('itiCur');
    var badge = document.getElementById('itiBadge');
    var steps = root.querySelectorAll('.iti-step');
    var btnPrev = document.getElementById('itiPrev');
    var btnNext = document.getElementById('itiNext');

    var AUTOPLAY_MS = 6000;
    var active = 0;
    var timer = null;
    var userInteracted = false;

    function renderBody(s) {
      var factsHtml = (s.facts || []).map(function (f) {
        return '<span class="iti-fact">' + (ICONS[f.i] || '') + f.t + '</span>';
      }).join('');
      body.innerHTML =
        '<div class="stage">' + (s.stage || '') + '</div>' +
        '<h3 class="title">' + (s.title || '') + '</h3>' +
        '<p class="desc">' + (s.desc || '') + '</p>' +
        '<div class="iti-card-facts">' + factsHtml + '</div>';
    }

    function activate(i, opts) {
      opts = opts || {};
      active = ((i % STOPS.length) + STOPS.length) % STOPS.length;
      var s = STOPS[active];
      card.setAttribute('data-stop', s.key);
      // Per-stop photo: a merchant image (from the block) wins; otherwise clear the
      // inline style so the CSS fallback (keyed by data-stop) shows through.
      if (fb) {
        if (s.img) { fb.style.backgroundImage = 'url("' + s.img + '")'; fb.style.backgroundPosition = 'center'; }
        else { fb.style.backgroundImage = ''; fb.style.backgroundPosition = ''; }
      }
      counter.textContent = String(active + 1).padStart(2, '0');
      badge.classList.toggle('hidden', !s.highlight);
      renderBody(s);

      steps.forEach(function (el, idx) {
        el.classList.toggle('active', idx === active);
        el.classList.toggle('visited', idx < active);
        el.classList.remove('playing');
        el.setAttribute('aria-selected', idx === active ? 'true' : 'false');
      });

      btnPrev.toggleAttribute('disabled', false);
      btnNext.toggleAttribute('disabled', false);

      if (opts.startAutoplay !== false && !userInteracted) restartAutoplay();
    }

    function next() { activate((active + 1) % STOPS.length); }
    function prev() { activate((active - 1 + STOPS.length) % STOPS.length); }

    function startAutoplay() {
      stopAutoplay();
      var activeStep = root.querySelector('.iti-step.active');
      if (activeStep) {
        activeStep.style.setProperty('--iti-autoplay', AUTOPLAY_MS + 'ms');
        void activeStep.offsetWidth;
        activeStep.classList.add('playing');
      }
      timer = setTimeout(function () {
        activate((active + 1) % STOPS.length, { startAutoplay: true });
      }, AUTOPLAY_MS);
    }
    function stopAutoplay() {
      if (timer) { clearTimeout(timer); timer = null; }
      root.querySelectorAll('.iti-step').forEach(function (s) { s.classList.remove('playing'); });
    }
    function restartAutoplay() { stopAutoplay(); startAutoplay(); }
    function markInteracted() { userInteracted = true; stopAutoplay(); }

    steps.forEach(function (el, idx) {
      el.addEventListener('click', function () { markInteracted(); activate(idx, { startAutoplay: false }); });
    });
    btnPrev.addEventListener('click', function () { markInteracted(); prev(); });
    btnNext.addEventListener('click', function () { markInteracted(); next(); });

    var touchStartX = 0, touchStartY = 0, touchActive = false;
    card.addEventListener('touchstart', function (e) {
      if (!e.touches[0]) return;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchActive = true;
    }, { passive: true });
    card.addEventListener('touchend', function (e) {
      if (!touchActive) return;
      touchActive = false;
      var t = e.changedTouches[0]; if (!t) return;
      var dx = t.clientX - touchStartX;
      var dy = t.clientY - touchStartY;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.4) {
        markInteracted();
        if (dx < 0) next(); else prev();
      }
    }, { passive: true });

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', function () { if (!userInteracted) startAutoplay(); });

    if ('IntersectionObserver' in window) {
      var visIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && !userInteracted) startAutoplay();
          else stopAutoplay();
        });
      }, { threshold: 0.35 });
      visIo.observe(root);
    }

    activate(0, { startAutoplay: false });
  })();

  /* ───────── booking widget — DEMO placeholder ─────────
     Visual mock only (no Shopify cart/checkout). Remove this block
     when the real booking app is integrated into <aside class="lx-book-aside">. */
  (function () {
    var grid = document.getElementById('pcalGrid');
    if (!grid) return;
    var titleEl = document.getElementById('pcalTitle');
    var prevBtn = document.getElementById('pcalPrev');
    var nextBtn = document.getElementById('pcalNext');
    var slots = document.getElementById('pslots');
    var guests = document.getElementById('pguests');
    var summary = document.getElementById('psummary');
    var cta = document.getElementById('pbookCta');
    var stepLbl = document.getElementById('pStepLabel');
    var steps = document.querySelectorAll('#pSteps .pstep');
    var PRICE = { adult: 15, child: 5 };
    var qty = { adult: 2, child: 0 };
    var months = ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'];
    var today = new Date(2026, 5, 8); today.setHours(0, 0, 0, 0);
    var minM = new Date(2026, 5, 1), maxM = new Date(2026, 8, 1);
    var view = new Date(2026, 5, 1);
    var selDate = null, selTime = null;

    function setSteps(n) {
      steps.forEach(function (s, k) { s.classList.toggle('done', k < n - 1); s.classList.toggle('on', k === n - 1); });
    }
    function render() {
      titleEl.textContent = months[view.getMonth()] + ' ' + view.getFullYear();
      grid.innerHTML = '';
      var lead = (new Date(view.getFullYear(), view.getMonth(), 1).getDay() + 6) % 7;
      var dim = new Date(view.getFullYear(), view.getMonth() + 1, 0).getDate();
      for (var k = 0; k < lead; k++) { var e = document.createElement('div'); e.className = 'pcal-cell empty'; grid.appendChild(e); }
      for (var d = 1; d <= dim; d++) {
        var cell = document.createElement('button'); cell.type = 'button'; cell.className = 'pcal-cell'; cell.textContent = d;
        var date = new Date(view.getFullYear(), view.getMonth(), d);
        if (date < today) { cell.classList.add('disabled'); cell.disabled = true; }
        if (selDate && date.getTime() === selDate.getTime()) cell.classList.add('sel');
        (function (date, cell) {
          cell.addEventListener('click', function () { if (cell.disabled) return; selDate = date; selTime = null; render(); openSlots(); });
        })(date, cell);
        grid.appendChild(cell);
      }
      prevBtn.disabled = (view.getFullYear() === minM.getFullYear() && view.getMonth() <= minM.getMonth());
      nextBtn.disabled = (view.getFullYear() === maxM.getFullYear() && view.getMonth() >= maxM.getMonth());
    }
    function openSlots() {
      slots.hidden = false;
      slots.querySelectorAll('input').forEach(function (i) { i.checked = false; });
      guests.hidden = true; summary.hidden = true; cta.hidden = true;
      setSteps(2); stepLbl.textContent = 'Passo 2: Scegli un orario';
    }
    function openGuests() {
      guests.hidden = false; summary.hidden = false; cta.hidden = false;
      setSteps(3); stepLbl.textContent = 'Passo 3: Partecipanti e riepilogo';
      updateGuestsUI(); updateSummary();
    }
    function updateGuestsUI() {
      document.getElementById('qAdult').textContent = qty.adult;
      document.getElementById('qChild').textContent = qty.child;
      document.querySelectorAll('#pguests .pstep-btn').forEach(function (b) {
        var g = b.dataset.g, d = +b.dataset.d;
        if (d < 0) b.disabled = qty[g] <= (g === 'adult' ? 1 : 0);
        else b.disabled = (qty.adult + qty.child) >= 12;
      });
    }
    function updateSummary() {
      var nice = selDate ? selDate.toLocaleDateString('it-IT', { weekday: 'long', day: 'numeric', month: 'long' }) : '—';
      document.getElementById('sumDate').textContent = nice;
      document.getElementById('sumTime').textContent = selTime ? ('ore ' + selTime) : '—';
      var aRow = document.getElementById('sumAdultRow'), cRow = document.getElementById('sumChildRow');
      aRow.querySelector('span').textContent = 'Adulti × ' + qty.adult;
      aRow.querySelector('b').textContent = '€' + (qty.adult * PRICE.adult);
      if (qty.child > 0) { cRow.hidden = false; cRow.querySelector('span').textContent = 'Bambini × ' + qty.child; cRow.querySelector('b').textContent = '€' + (qty.child * PRICE.child); }
      else { cRow.hidden = true; }
      document.getElementById('sumTotal').textContent = '€' + (qty.adult * PRICE.adult + qty.child * PRICE.child);
      cta.disabled = (qty.adult + qty.child) < 1;
    }
    prevBtn.addEventListener('click', function () { view = new Date(view.getFullYear(), view.getMonth() - 1, 1); render(); });
    nextBtn.addEventListener('click', function () { view = new Date(view.getFullYear(), view.getMonth() + 1, 1); render(); });
    slots.addEventListener('change', function (e) { if (e.target.name === 'ptime') { selTime = e.target.value; openGuests(); } });
    guests.addEventListener('click', function (e) {
      var b = e.target.closest('.pstep-btn'); if (!b) return;
      var g = b.dataset.g, d = +b.dataset.d, min = (g === 'adult' ? 1 : 0);
      var nextQ = Math.max(min, Math.min(12, qty[g] + d));
      if ((g === 'adult' ? nextQ + qty.child : qty.adult + nextQ) <= 12) qty[g] = nextQ;
      updateGuestsUI(); updateSummary();
    });
    cta.addEventListener('click', function () {
      if (!selDate || !selTime) return;
      var nice = selDate.toLocaleDateString('it-IT', { weekday: 'long', day: 'numeric', month: 'long' });
      var total = qty.adult * PRICE.adult + qty.child * PRICE.child;
      var parts = [qty.adult + ' adult' + (qty.adult > 1 ? 'i' : 'o')];
      if (qty.child > 0) parts.push(qty.child + ' bambin' + (qty.child > 1 ? 'i' : 'o'));
      var inner = document.querySelector('#pbook .pbook-inner');
      inner.innerHTML = '<div class="pbook-done"><div class="pbook-check"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></div><div class="pbook-done-title">Prenotazione confermata</div><div class="pbook-done-sub">' + nice + ' · ore ' + selTime + '<br>' + parts.join(' · ') + ' · €' + total + '</div><button class="pbook-cta" type="button" style="margin-top:18px;">Vai al checkout</button></div>';
    });
    render();
  })();
})();
